import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import VueSocketIO from 'vue-socket.io'

Vue.config.productionTip = false

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);

if (window.location.href.includes("localhost")) {
    store.commit("setEnv", "dev")
} else {
    store.commit("setEnv", "prod")
}

store.commit("setEnv", "prod")

Vue.use(new VueSocketIO({
    debug: false,
    connection: store.state.socketUrl,
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    },
    options: {
        secure: true,
        rejectUnauthorized: false
    }
}))




new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')